export default __webpack_public_path__ + "static/media/industrial-icon.109853a8.png";